import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate, Link } from "react-router-dom";
import DataTable from "../../admin/components/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import { CustomAlert, showToastAlert } from "../../admin/components/CustomAlert";
import { getPosts } from "../../services/writerPost";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const PostHome = () => {
  const [loaderOpen, setLoaderOpen] = React.useState(true);
  const [apiData, setApiData] = React.useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();
  const token = useSelector((state) => state.token);

  const tableColumns = [
    {
      field: "title",
      headerName: "TITLE",
      flex: 1,
      editable: false,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 230,
      editable: false,
      renderCell: (params) => (
        <div>
          <Tooltip title="Show Post Details">
            <Button
              variant="outlined"
              onClick={() => handlePostView(params)}
              className="circular-btn me-2"
              startIcon={<RemoveRedEyeRoundedIcon />}
            />
          </Tooltip>
          <Tooltip title="Edit Post Details">
            <Button
              variant="outlined"
              onClick={() => editPostView(params)}
              className="circular-btn me-2"
              startIcon={<EditIcon />}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoaderOpen(true);
      const response = await getPosts(token);
      if (response.status !== 200) {
        showToastAlert(response?.data?.message, "error");
        return;
      }
      setApiData(response.data.posts);
      setLoaderOpen(false);
    } catch (err) {
      throw new Error(err);
    }
  };

  const handlePostView = (params) => {
    const slug = params.row.slug;
    window.open(`/internships/detail/${slug}`)
  };

  const handleNewPost = () => {
    navigate("/writer/post/new");
  };

  const editPostView = (params) => {
    const id = params.row._id;
    navigate(`/writer/post/${id}`);
  };

  const handleClose = () => {
    setShowAlert(false);
  };

  return (
    <div className="container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "20px"
        }}
      >
        <Box mb={3}>
          <Button
            variant="outlined"
            component={Link}
            to="/writer"
            startIcon={<ArrowBackIcon />}
            sx={{ background: "yellow" }}
          >
            Home
          </Button>
        </Box>
        <h1 className="page-title-1 my-3">Posts</h1>
        <button onClick={handleNewPost} className="btn btn-primary">
          New Post
        </button>
      </div>
      <DataTable data={apiData} columns={tableColumns} id="_id" />
      <CustomAlert />
    </div>
  );
};

export default PostHome;
